import React from "react"

import BasePermissionGate, { BasePermissionGateProps } from "@/components/PermissionGate/BasePermissionGate"

const ContactNoteGroupPermissionGate = (props: Omit<BasePermissionGateProps<"contact-note">, "feature">) => {
	return (
		<BasePermissionGate
			{...props}
			feature="contact-note"
		/>
	)
}

export default ContactNoteGroupPermissionGate
